import { axios } from '@/lib/axios';

export const getProductsByCategory = async (id: number) => {
    const { data } = await axios.get(`v1/get-products-by-category/${id}`);
    return data.products;
};
export const getProductsWithCategory = async (id: number) => {
    const { data } = await axios.get(`v1/get-products-with-category/${id}`);
    return data.products;
};
export const getLocaionProductsByCategory = async (id: number) => {
    const { data } = await axios.get(`v1/get-products-by-menu/${id}`);
    return data.products;
};
